import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  reduxForm, getFormValues, change, getFormSyncErrors,
} from 'redux-form';
import Modal from 'react-modal';
import { t } from 'i18next';
import putReduxCompanies from './actions';
import {
  createUser,
  updateUserById,
  deleteUserById,
  getManageUserById,
  getUserById,
  removeUserFromCompany,
} from '../../services/users';
import {
  getCompanyInfo,
  getCompaniesList,
  getUserManagementCompaniesList,
} from '../../services/companies';
import { formDataToApi, formApiToData } from '../../services/users/helpers';
import {
  ButtonGroup,
  FormContainer,
} from './css';
import PrimaryButton from '../../lib/ui/buttons/PrimaryButton';
import SecondaryButton from '../../lib/ui/buttons/SecondaryButton';
import {
  ModalTitle,
  Close,
  ModalBody,
  ButtonDiv,
} from '../ManageUsers/css';
import UserForm from './components/UserForm';
import { homeUrlNoTrailingSlash } from '../../utils/func';
import { routes } from '../../utils/constants';
import ModalBoxStyle from '../_styledComponents/ModalBoxStyle';
import LeavePageModal from '../ReactComponent/LeavePageModal';

const formName = 'CreateUserForm';
const initialValues = {
  companies: [{}],
};
const ModalContent = ({
  closeModal, handleDeleteUser, errorMessages, successAction, goToManage,
}) => (
  successAction ? (
    <>
      <ModalTitle>{t('Success')}</ModalTitle>
      <p>{`${t('User')} ${t(successAction)} ${t('Successfully')}`}</p>
      <p>{t('You will now be taken to Manage Users')}</p>
      <ButtonDiv>
        <SecondaryButton
          onClick={() => goToManage()}
          className="active min-width"
          showArrow={false}
        >
          {t('Accept')}
        </SecondaryButton>
      </ButtonDiv>
    </>
  )
    : errorMessages.length > 0
      ? (
        <>
          <ModalTitle>{t('Error')}</ModalTitle>
          {errorMessages.map((error) => <p key={error.errorMessage}>{t(error.errorMessage)}</p>)}
          <ButtonDiv>
            <SecondaryButton
              onClick={() => closeModal()}
              className="active min-width"
              showArrow={false}
            >
              {t('Accept')}
            </SecondaryButton>
          </ButtonDiv>
        </>
      )
      : (
        <>
          <ModalTitle>{t('DeleteUser')}</ModalTitle>
          {t('DeleteUserPrompt')}
          <ButtonDiv>
            <SecondaryButton
              onClick={() => closeModal()}
              className="active min-width"
              showArrow={false}
            >
              {t('Cancel')}
            </SecondaryButton>
            <PrimaryButton
              onClick={() => handleDeleteUser()}
              className="active min-width"
              showArrow={false}
            >
              {t('RemoveUser')}
            </PrimaryButton>
          </ButtonDiv>
        </>
      )
);

class CreateUserForm extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      companiesList: [],
      userId: '',
      companyDetails: [],
      modalIsOpen: false,
      errorMessages: [],
      leaveModalIsOpen: false,
      removeCompanyModalIsOpen: false,
      companyToRemove: null,
      deleteUserModalIsOpen: false,
      selectedCompaniesToDelete: [],
      toggleStatusModalIsOpen: false,
      currentUserIsDisabled: false,
      selectedCompaniesToToggle: [],
    };
  }

  componentDidMount() {
    if (typeof window !== 'undefined') {
      const urlParams = new URLSearchParams(window.location.search);
      const userId = urlParams.get('userId') || urlParams.get('userEmail');
      if (userId) {
        this.handleUserId(userId);
      } else {
        this.fetchAllCompanies(this.props.userId);
      }
    }
  }

  handleUserId = (userid) => {
    const { division: profileDivision, userId } = this.props;
    const urlParams = new URLSearchParams(window.location.search);
    const division = urlParams.get('division') || profileDivision;

    if (urlParams.get('userEmail')) {
      getUserById(division, userid)
        // eslint-disable-next-line consistent-return
        .then((response) => {
          if (response.data) {
            this.setState({ userId: response.data.userId });
            const { data } = response;
            return this.fetchAllCompanies(data.userId).then(() => data);
          }
        })
        .then((data) => {
          const { companiesList } = this.state;
          // eslint-disable-next-line no-undef
          const formedData = formApiToData(data, companiesList);
          formedData.companies.forEach((c, index) => {
            this.getCompanyInfo(c.companyId, index, c.originalCompanyId);
          });
          this.dispatchFormValues(formedData);
        });
    } else {
      getManageUserById(division, userid, userId)
        .then((response) => {
          if (response.data) {
            this.setState({ userId: response.data.userId });
            const { data } = response;
            this.fetchAllCompanies(data.userId).then(() => {
              const { companiesList } = this.state;
              const formedData = formApiToData(data, companiesList);
              formedData.companies.forEach((c, index) => this.getCompanyInfo(c.companyId, index, c.originalCompanyId));
              this.dispatchFormValues(formedData);
            });
          }
        });
    }
  };

  dispatchFormValues = (data) => {
    const { dispatch } = this.props;
    Object.keys(data).map((field) => dispatch(change(formName, field, data[field])));
  };

  // eslint-disable-next-line consistent-return
  fetchAllCompanies = (userid) => {
    const { division: profileDivision, userId } = this.props;
    const urlParams = new URLSearchParams(window.location.search);
    const division = urlParams.get('division') || profileDivision;
    if (urlParams.get('page') === 'manage-companies') {
      if (localStorage.getItem('view/editCompanyData')) {
        const storedViewEditData = localStorage.getItem('view/editCompanyData');
        if (storedViewEditData) {
          const parsedData = JSON.parse(storedViewEditData);
          this.state.companiesList.push(parsedData);
        }

        localStorage.removeItem('view/editCompanyData');
      } else if (localStorage.getItem('addCompanydata')) {
        const storedAddCompanyData = localStorage.getItem('addCompanydata');
        if (storedAddCompanyData) {
          const parsedData = JSON.parse(storedAddCompanyData);
          this.setState({ companiesList: parsedData });
        }

        localStorage.removeItem('addCompanydata');
      }

      getUserManagementCompaniesList(division, userid, userId).then((res) => {
        if (res.status === 200) {
          const { putReduxCompanies } = this.props;
          putReduxCompanies(res.data);
        }
      });
    } else if (urlParams.get('userEmail')) {
      return getCompaniesList(division, userid).then((res) => {
        if (res.status === 200) {
          const { putReduxCompanies } = this.props;

          const filteredCompanies = res.data.filter(
            (company) => company.division === division.toLowerCase(),
          );

          putReduxCompanies(filteredCompanies);
          this.setState({ companiesList: filteredCompanies });
        }
      });
    } else {
      return getUserManagementCompaniesList(division, userid, userId).then((res) => {
        if (res.status === 200) {
          const { putReduxCompanies } = this.props;

          const filteredCompanies = res.data.filter(
            (company) => company.division === division.toLowerCase(),
          );

          putReduxCompanies(filteredCompanies);
          this.setState({ companiesList: filteredCompanies });
        }
      });
    }
  };

  goToManage = (e) => {
    if (e) {
      e.preventDefault();
    }

    window.location.href = `${homeUrlNoTrailingSlash()}${routes.manageUsers}`;
  };

  handleDeleteUser = async () => {
    const { userId } = this.state;

    deleteUserById(userId).then((res) => {
      if (res.status === 200 || res.status === 201 || res.status === 204) {
        this.openModal('deleted');
      }
    });
  };

  getCompanyInfo = (companyIdValue, index, originalCompanyId) => {
    const { dispatch } = this.props;
    dispatch(change(formName, `companies[${index}]`, { companyId: companyIdValue }));
    const companyID = originalCompanyId || companyIdValue;

    getCompanyInfo(companyID).then((res) => {
      this.setState((prevState) => {
        const companyDetailsCopy = { ...prevState.companyDetails };
        companyDetailsCopy[index] = res.data;
        return { companyDetails: companyDetailsCopy };
      },
      () => this.selectShippingPermission(index),
      );
    });
  };

  handleSubmit = () => {
    const {
      formData,
      isAuthenticated,
      division: profileDivision,
    } = this.props;
    const { userId, companiesList } = this.state;
    const urlParams = new URLSearchParams(window.location.search);
    const division = urlParams.get('division') || profileDivision;
    if (isAuthenticated) {
      const changedData = formDataToApi(formData, division, companiesList);
      if (formData.rowVersion) {
        updateUserById(changedData, userId).then((res) => {
          if (res.status === 200 || res.status === 201 || res.status === 204) {
            this.openModal('updated');
          }
        }).catch((error) => {
          if (error.response && error.response.data && error.response.data.errors && error.response.data.errors.length > 0) {
            this.setState({ modalIsOpen: true, errorMessages: error.response.data.errors });
          } else {
            this.setState({ modalIsOpen: true, errorMessages: [{ errorMessage: 'GeneralError' }] });
          }
        });
      } else {
        createUser(changedData).then((res) => {
          if (res.status === 200 || res.status === 201 || res.status === 204) {
            this.openModal('created');
          }
        }).catch((error) => {
          if (error.response && error.response.status) {
            this.setState({ modalIsOpen: true, errorMessages: error.response.data.errors });
          }
        });
      }
    }
  };

  openModal = (successAction) => {
    this.setState({
      modalIsOpen: true,
      successAction,
    });
  };

  closeModal = () => {
    this.setState({ modalIsOpen: false, errorMessages: [] });
  };

  openRemoveCompanyModal = (companyId, companyName) => {
    this.setState({
      removeCompanyModalIsOpen: true,
      companyToRemove: { companyId, companyName },
    });
  };

  closeRemoveCompanyModal = () => {
    this.setState({
      removeCompanyModalIsOpen: false,
      companyToRemove: null,
    });
  };

  handleRemoveFromCompany = async () => {
    const { companyToRemove } = this.state;
    const { division: profileDivision, formData } = this.props;
    const urlParams = new URLSearchParams(window.location.search);
    const division = urlParams.get('division') || profileDivision;
    const userEmail = formData.email;

    if (!companyToRemove || !userEmail) return;

    this.closeRemoveCompanyModal();

    try {
      const response = await removeUserFromCompany(division, userEmail, companyToRemove.companyId);
      if (response && (response.status === 200 || response.status === 204)) {
        // Reload the page to reflect changes
        window.location.reload();
      }
    } catch (error) {
      this.setState({
        modalIsOpen: true,
        errorMessages: error.response?.data?.errors || [{ errorMessage: 'GeneralError' }],
      });
    }
  };

  openDeleteUserModal = () => {
    const { formData } = this.props;
    const companies = formData?.companies || [];
    // Pre-select all companies by default
    const allCompanyIds = companies
      .filter((c) => c.companyId)
      .map((c) => c.companyId);
    this.setState({
      deleteUserModalIsOpen: true,
      selectedCompaniesToDelete: allCompanyIds,
    });
  };

  closeDeleteUserModal = () => {
    this.setState({
      deleteUserModalIsOpen: false,
      selectedCompaniesToDelete: [],
    });
  };

  toggleCompanySelection = (companyId) => {
    const { selectedCompaniesToDelete } = this.state;
    if (selectedCompaniesToDelete.includes(companyId)) {
      this.setState({
        selectedCompaniesToDelete: selectedCompaniesToDelete.filter((id) => id !== companyId),
      });
    } else {
      this.setState({
        selectedCompaniesToDelete: [...selectedCompaniesToDelete, companyId],
      });
    }
  };

  toggleAllCompanies = () => {
    const { formData } = this.props;
    const { selectedCompaniesToDelete } = this.state;
    const companies = formData?.companies || [];
    const allCompanyIds = companies
      .filter((c) => c.companyId)
      .map((c) => c.companyId);

    if (selectedCompaniesToDelete.length === allCompanyIds.length) {
      // Deselect all
      this.setState({ selectedCompaniesToDelete: [] });
    } else {
      // Select all
      this.setState({ selectedCompaniesToDelete: allCompanyIds });
    }
  };

  handleDeleteUserFromCompanies = async () => {
    const { selectedCompaniesToDelete } = this.state;
    const { division: profileDivision, formData } = this.props;
    const { userId } = this.state;
    const urlParams = new URLSearchParams(window.location.search);
    const division = urlParams.get('division') || profileDivision;
    const userEmail = formData.email;
    const companies = formData?.companies || [];
    const allCompanyIds = companies
      .filter((c) => c.companyId)
      .map((c) => c.companyId);

    if (!selectedCompaniesToDelete.length || !userEmail) return;

    this.closeDeleteUserModal();

    try {
      // If all companies are selected, delete the user entirely
      if (selectedCompaniesToDelete.length === allCompanyIds.length) {
        const response = await deleteUserById(userId);
        if (response && (response.status === 200 || response.status === 201 || response.status === 204)) {
          this.openModal('deleted');
        }
      } else {
        // Remove user from selected companies in parallel
        const removePromises = selectedCompaniesToDelete.map(
          (companyId) => removeUserFromCompany(division, userEmail, companyId),
        );
        await Promise.all(removePromises);

        // Reload the page to reflect changes
        window.location.reload();
      }
    } catch (error) {
      this.setState({
        modalIsOpen: true,
        errorMessages: error.response?.data?.errors || [{ errorMessage: 'GeneralError' }],
      });
    }
  };

  openToggleStatusModal = (isCurrentlyDisabled) => {
    const { formData } = this.props;
    const companies = formData?.companies || [];
    const allCompanyIds = companies
      .filter((c) => c.companyId)
      .map((c) => c.companyId);
    this.setState({
      toggleStatusModalIsOpen: true,
      currentUserIsDisabled: isCurrentlyDisabled,
      selectedCompaniesToToggle: allCompanyIds,
    });
  };

  closeToggleStatusModal = () => {
    this.setState({
      toggleStatusModalIsOpen: false,
      selectedCompaniesToToggle: [],
    });
  };

  toggleCompanySelectionForStatus = (companyId) => {
    const { selectedCompaniesToToggle } = this.state;
    if (selectedCompaniesToToggle.includes(companyId)) {
      this.setState({
        selectedCompaniesToToggle: selectedCompaniesToToggle.filter((id) => id !== companyId),
      });
    } else {
      this.setState({
        selectedCompaniesToToggle: [...selectedCompaniesToToggle, companyId],
      });
    }
  };

  toggleAllCompaniesForStatus = () => {
    const { formData } = this.props;
    const { selectedCompaniesToToggle } = this.state;
    const companies = formData?.companies || [];
    const allCompanyIds = companies
      .filter((c) => c.companyId)
      .map((c) => c.companyId);

    if (selectedCompaniesToToggle.length === allCompanyIds.length) {
      this.setState({ selectedCompaniesToToggle: [] });
    } else {
      this.setState({ selectedCompaniesToToggle: allCompanyIds });
    }
  };

  handleToggleUserStatus = async () => {
    const {
      currentUserIsDisabled, userId, companiesList, selectedCompaniesToToggle,
    } = this.state;
    const { division: profileDivision, formData } = this.props;
    const urlParams = new URLSearchParams(window.location.search);
    const division = urlParams.get('division') || profileDivision;

    const newIsActive = currentUserIsDisabled; // If disabled, activate; if active, deactivate
    const companies = formData?.companies || [];
    const allCompanyIds = companies.filter((c) => c.companyId).map((c) => c.companyId);
    const allSelected = selectedCompaniesToToggle.length === allCompanyIds.length;

    this.closeToggleStatusModal();

    try {
      const changedData = formDataToApi(formData, division, companiesList);
      // Convert selectedCompaniesToToggle to strings for comparison
      const selectedIds = selectedCompaniesToToggle.map((id) => String(id));

      if (allSelected) {
        // Update overall user isActive status
        changedData.isActive = newIsActive;
      } else {
        // Update isActive only for selected companies
        changedData.companies = changedData.companies.map((c) => ({
          ...c,
          isActive: selectedIds.includes(String(c.companyId)) ? newIsActive : c.isActive,
        }));
      }

      const response = await updateUserById(changedData, userId);
      if (response && (response.status === 200 || response.status === 204)) {
        window.location.reload();
      }
    } catch (error) {
      this.setState({
        modalIsOpen: true,
        errorMessages: error.response?.data?.errors || [{ errorMessage: 'GeneralError' }],
      });
    }
  };

  selectShippingPermission(index) {
    const { dispatch, formData: { companies } } = this.props;
    const { companyDetails } = this.state;
    if (companies[index] && !companies[index].permissions) {
      companies[index].permissions = companyDetails[index].permissions.filter((c) => c.permissionName === 'Shipping');
    } else if (companies[index].permissions.filter((c) => c.permissionName === 'Shipping').length < 1) {
      companies[index].permissions.push(companyDetails[index].permissions.filter((c) => c.permissionName === 'Shipping'));
    }

    dispatch(change(formName, `companies[${index}].permissions`, companies[index].permissions));
  }

  render() {
    const {
      formData, handleSubmit, dispatch, fields, valid, formSyncError,
    } = this.props;
    const {
      companiesList,
      companyDetails,
      modalIsOpen,
      userId,
      errorMessages,
      leaveModalIsOpen,
      successAction,
      removeCompanyModalIsOpen,
      companyToRemove,
      deleteUserModalIsOpen,
      selectedCompaniesToDelete,
      toggleStatusModalIsOpen,
      currentUserIsDisabled,
      selectedCompaniesToToggle,
    } = this.state;

    const userCompanies = formData?.companies?.filter((c) => c.companyId) || [];
    const allCompanyIds = userCompanies.map((c) => c.companyId);
    const allSelected = selectedCompaniesToDelete.length === allCompanyIds.length && allCompanyIds.length > 0;
    const allSelectedForToggle = selectedCompaniesToToggle.length === allCompanyIds.length
      && allCompanyIds.length > 0;

    return (
      <>
        <Modal
          isOpen={modalIsOpen}
          // onRequestClose={this.closeModal}
          style={ModalBoxStyle}
          contentLabel="Modal"
        >
          <Close onClick={() => this.closeModal()} />
          <ModalBody className="justify-content-center">
            <ModalContent
              closeModal={this.closeModal}
              handleDeleteUser={this.handleDeleteUser}
              errorMessages={errorMessages}
              goToManage={this.goToManage}
              successAction={successAction}
            />
          </ModalBody>
        </Modal>
        <Modal
          isOpen={removeCompanyModalIsOpen}
          style={ModalBoxStyle}
          contentLabel="Remove Company Modal"
        >
          <Close onClick={() => this.closeRemoveCompanyModal()} />
          <ModalBody className="justify-content-center">
            <ModalTitle>{t('RemoveFromCompany')}</ModalTitle>
            <p>
              {t('RemoveFromCompanyPrompt')}
              {' '}
              <strong>{companyToRemove?.companyName}</strong>
              ?
            </p>
            <ButtonDiv>
              <SecondaryButton
                onClick={() => this.closeRemoveCompanyModal()}
                className="active min-width"
                showArrow={false}
              >
                {t('Cancel')}
              </SecondaryButton>
              <PrimaryButton
                onClick={() => this.handleRemoveFromCompany()}
                className="active min-width"
                showArrow={false}
              >
                {t('RemoveFromCompanyButton')}
              </PrimaryButton>
            </ButtonDiv>
          </ModalBody>
        </Modal>
        <Modal
          isOpen={deleteUserModalIsOpen}
          style={ModalBoxStyle}
          contentLabel="Delete User Modal"
        >
          <Close onClick={() => this.closeDeleteUserModal()} />
          <ModalBody className="justify-content-center">
            <ModalTitle>{t('DeleteUser')}</ModalTitle>
            <p>{t('SelectCompaniesToRemoveUser')}</p>
            <div style={{ margin: '20px 0', textAlign: 'left' }}>
              <div
                role="checkbox"
                aria-checked={allSelected}
                tabIndex={0}
                onClick={() => this.toggleAllCompanies()}
                onKeyPress={(e) => e.key === 'Enter' && this.toggleAllCompanies()}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  marginBottom: '12px',
                  cursor: 'pointer',
                }}
              >
                <input
                  type="checkbox"
                  checked={allSelected}
                  onChange={() => this.toggleAllCompanies()}
                  style={{
                    marginRight: '10px',
                    width: '18px',
                    height: '18px',
                  }}
                />
                <strong>{t('AllCompanies')}</strong>
              </div>
              <hr style={{ margin: '12px 0', borderColor: '#ddd' }} />
              {userCompanies.map((company) => {
                const companyInfo = companiesList.find((c) => c.companyId === company.companyId);
                const companyName = companyInfo?.companyName || company.companyId;
                return (
                  <div
                    key={company.companyId}
                    role="checkbox"
                    aria-checked={selectedCompaniesToDelete.includes(company.companyId)}
                    tabIndex={0}
                    onClick={() => this.toggleCompanySelection(company.companyId)}
                    onKeyPress={(e) => e.key === 'Enter' && this.toggleCompanySelection(company.companyId)}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      marginBottom: '10px',
                      cursor: 'pointer',
                    }}
                  >
                    <input
                      type="checkbox"
                      checked={selectedCompaniesToDelete.includes(company.companyId)}
                      onChange={() => this.toggleCompanySelection(company.companyId)}
                      style={{
                        marginRight: '10px',
                        width: '18px',
                        height: '18px',
                      }}
                    />
                    {companyName}
                  </div>
                );
              })}
            </div>
            <ButtonDiv>
              <SecondaryButton
                onClick={() => this.closeDeleteUserModal()}
                className="active min-width"
                showArrow={false}
              >
                {t('Cancel')}
              </SecondaryButton>
              <PrimaryButton
                onClick={() => this.handleDeleteUserFromCompanies()}
                className="active min-width"
                showArrow={false}
                disabled={selectedCompaniesToDelete.length === 0}
              >
                {t('RemoveUser')}
              </PrimaryButton>
            </ButtonDiv>
          </ModalBody>
        </Modal>
        <Modal
          isOpen={toggleStatusModalIsOpen}
          style={ModalBoxStyle}
          contentLabel="Toggle User Status Modal"
        >
          <Close onClick={() => this.closeToggleStatusModal()} />
          <ModalBody className="justify-content-center">
            <ModalTitle>
              {currentUserIsDisabled ? t('ActivateUser') : t('DeactivateUser')}
            </ModalTitle>
            <p>
              {currentUserIsDisabled
                ? t('ActivateUserPrompt')
                : t('DeactivateUserPrompt')}
            </p>
            <p style={{ fontWeight: '500', marginTop: '15px' }}>
              {t('SelectCompaniesToToggleStatus')}
            </p>
            <div style={{ textAlign: 'left', marginTop: '10px' }}>
              <div
                role="checkbox"
                aria-checked={allSelectedForToggle}
                tabIndex={0}
                onClick={() => this.toggleAllCompaniesForStatus()}
                onKeyPress={(e) => e.key === 'Enter' && this.toggleAllCompaniesForStatus()}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  marginBottom: '10px',
                  cursor: 'pointer',
                }}
              >
                <input
                  type="checkbox"
                  checked={allSelectedForToggle}
                  onChange={() => this.toggleAllCompaniesForStatus()}
                  style={{
                    marginRight: '10px',
                    width: '18px',
                    height: '18px',
                  }}
                />
                <strong>{t('AllCompanies')}</strong>
              </div>
              <hr style={{ margin: '12px 0', borderColor: '#ddd' }} />
              {userCompanies.map((company) => {
                const companyInfo = companiesList.find((c) => c.companyId === company.companyId);
                const companyName = companyInfo?.companyName || company.companyId;
                return (
                  <div
                    key={company.companyId}
                    role="checkbox"
                    aria-checked={selectedCompaniesToToggle.includes(company.companyId)}
                    tabIndex={0}
                    onClick={() => this.toggleCompanySelectionForStatus(company.companyId)}
                    onKeyPress={(e) => {
                      if (e.key === 'Enter') this.toggleCompanySelectionForStatus(company.companyId);
                    }}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      marginBottom: '10px',
                      cursor: 'pointer',
                    }}
                  >
                    <input
                      type="checkbox"
                      checked={selectedCompaniesToToggle.includes(company.companyId)}
                      onChange={() => this.toggleCompanySelectionForStatus(company.companyId)}
                      style={{
                        marginRight: '10px',
                        width: '18px',
                        height: '18px',
                      }}
                    />
                    {companyName}
                  </div>
                );
              })}
            </div>
            <ButtonDiv>
              <SecondaryButton
                onClick={() => this.closeToggleStatusModal()}
                className="active min-width"
                showArrow={false}
              >
                {t('Cancel')}
              </SecondaryButton>
              <PrimaryButton
                onClick={() => this.handleToggleUserStatus()}
                className="active min-width"
                showArrow={false}
                disabled={selectedCompaniesToToggle.length === 0}
              >
                {currentUserIsDisabled ? t('Activate') : t('Deactivate')}
              </PrimaryButton>
            </ButtonDiv>
          </ModalBody>
        </Modal>
        <LeavePageModal isOpen={leaveModalIsOpen} onClose={() => this.setState({ leaveModalIsOpen: false })} onContinue={() => this.goToManage()} />
        <FormContainer>
          <form onSubmit={handleSubmit(this.handleSubmit)}>
            <UserForm
              fields={fields}
              formData={formData}
              dispatch={dispatch}
              formName={formName}
              companiesList={companiesList}
              deleteUser={this.openDeleteUserModal}
              getCompanyInfo={this.getCompanyInfo}
              companyDetails={companyDetails}
              valid={valid}
              showAdd={!!userId}
              error={formSyncError}
              onRemoveCompany={this.openRemoveCompanyModal}
              onToggleUserStatus={this.openToggleStatusModal}
            />
            <ButtonGroup>
              <SecondaryButton type="button" className="active" onClick={() => this.setState({ leaveModalIsOpen: true })} isIconLeftPosition>
                {t('Cancel')}
              </SecondaryButton>
              <PrimaryButton type="submit" className="submit" showArrow={false}>
                {t('SaveChanges')}
              </PrimaryButton>
            </ButtonGroup>
          </form>
        </FormContainer>
      </>
    );
  }
}

CreateUserForm = reduxForm({
  form: formName, // a unique identifier for this form
  initialValues,
})(CreateUserForm);

const mstp = (state) => ({
  formData: getFormValues(formName)(state),
  formSyncError: getFormSyncErrors(formName)(state),
  isAuthenticated: state.profile.isAuthenticated,
  division: state.profile.division,
  userId: state.profile.userId,
  email: state.profile.email,
});

const mdtp = (dispatch) => ({
  putReduxCompanies: (companiesList) => dispatch(putReduxCompanies(companiesList)),
});

export default connect(mstp, mdtp)(CreateUserForm);

CreateUserForm.propTypes = {
  dispatch: PropTypes.func,
  fields: PropTypes.object,
  formData: PropTypes.object,
  formSyncError: PropTypes.object,
  handleSubmit: PropTypes.func,
  isAuthenticated: PropTypes.bool,
  division: PropTypes.string,
  userId: PropTypes.string,
  putReduxCompanies: PropTypes.func,
  valid: PropTypes.bool,
};

ModalContent.propTypes = {
  closeModal: PropTypes.func,
  handleDeleteUser: PropTypes.func,
  errorMessages: PropTypes.array,
  successAction: PropTypes.string,
  goToManage: PropTypes.func,
};
